import { render, staticRenderFns } from "./settlement-detail.vue?vue&type=template&id=630e1af2&scoped=true"
import script from "./settlement-detail.vue?vue&type=script&lang=js"
export * from "./settlement-detail.vue?vue&type=script&lang=js"
import style0 from "./settlement-detail.vue?vue&type=style&index=0&id=630e1af2&prod&lang=scss&scoped=true"
import style1 from "./settlement-detail.vue?vue&type=style&index=1&id=630e1af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e1af2",
  null
  
)

export default component.exports